import leakSeverity from '@/assets/imges/leak-severity.png'
import leakCenter from '@/assets/imges/leak-center.png'
import leakLow from '@/assets/imges/leak-low.png'
import leakHigh from '@/assets/imges/leak-high.png'
import { t } from '@/i18n'

export const riskLevelMap = {
  RiskLevelLow: { label: t('低危'), class: 'leak-low', iconSrc: leakLow },
  RiskLevelMiddle: { label: t('中危'), class: 'leak-center', iconSrc: leakCenter },
  RiskLevelHigh: { label: t('高危'), class: 'leak-high', iconSrc: leakHigh },
  RiskLevelGross: { label: t('严重'), class: 'leak-severity', iconSrc: leakSeverity },
}

export const interceptStatusMap = {
  intercept_status_intercept_success: { label: t('拦截成功'), class: 'intercept-success' },
  intercept_status_intercept_defence_fail: { label: t('防护失效'), class: 'intercept-fail' },
  intercept_status_detect_success: { label: t('检测成功'), class: 'detection-success' },
}

export const confidenceLevelMap = {
  1: { label: t('低') },
  2: { label: t('中') },
  3: { label: t('高') },
}

export const cardSystemTypeMap = {
  '1': { name: 'windows', width: 18, height: 18, style: { marginRight: 8 } },
  '3': { name: 'linux', width: 18, height: 18, style: { marginRight: 8 } },
  '4': { name: 'UOS', width: 18, height: 18, style: { marginRight: 8 } },
}

export const resourceLevelMap = {
  ResourceLevelJunior: { label: t('初级'), class: 'case-level-low' },
  ResourceLevelMiddle: { label: t('中级'), class: 'case-level-center' },
  ResourceLevelSenior: { label: t('高级'), class: 'case-level-high' },
}

export const logAlarmMap = {
  alertLogYes: { label: t('有告警'), class: 'log-alarm-success' },
  alertLogNo: { label: t('无告警'), class: 'log-alarm-fail' },
}

export const statusMap = {
  2: { label: t('进行中'), color: '#2973FF', background: '#DBE8FF' },
  3: { label: t('已完成'), color: '#67c23a', background: '#E4F7D1' },
  4: { label: t('中断'), color: '#F53F3F', background: '#FFDCE0' },
  7: { label: t('停止中'), color: '#FF9900', background: '#FFEFD7' },
}

export const importModalOptions = [
  { label: 'TIP', value: 'TIP', disabled: false },
  { label: 'SOC', value: 'SOC', disabled: false },
]
